import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-drag-n-drop',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './drag-n-drop.component.html',
  styleUrls: ['./drag-n-drop.component.scss'],
})
export class DragNDropComponent implements OnInit {
  @Input() data: any = {}; 

  defaultConfigs: any = {
    label: 'Upload files or directory',
    labelTooltip: 'Drag and drop files or click to upload.',
    tooltipIcon: 'info',
    placeholder: 'Drag & drop (or) Click to select',
    displayFileList: false,
    button: {
      text: 'Browse',
      class: 'btn-accello-outlined',
    },
    fileTypes: ['XLS', 'CSV'],
  };

  configs: any;
  droppedFiles: File[] = []; 

  ngOnInit() {
    this.configs = {
      ...this.defaultConfigs,
      ...this.data,
      button: {
        ...this.defaultConfigs.button,
        ...this.data.button,
      },
    };
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault(); 
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault(); 
    event.stopPropagation();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault(); 
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      Array.from(files).forEach((file) => {
        if (!this.droppedFiles.find((existingFile) => existingFile.name === file.name)) {
          this.droppedFiles.push(file); 
        }
      });
      console.log('Dropped files:', this.droppedFiles);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input && input.files) {
      Array.from(input.files).forEach((file) => {
        if (!this.droppedFiles.find((existingFile) => existingFile.name === file.name)) {
          this.droppedFiles.push(file);
        }
      });
      console.log('Selected files:', this.droppedFiles);
    }
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput?.click();
  }
}
